export class Spring{

  constructor(options){
    //options
    this.maxSpeed = 0.2;
    this.damping = 0.80;
    this.accelerationMultiplier = 0.25;

    Object.assign(this, options);

    this.output = 0;
    this.velocity = 0;
  }


  reset(input){
    this.output=input;
    this.velocity=0;
  }

  process(input){
    var dist = input - this.output;
    var acceleration = dist *  this.accelerationMultiplier;
    this.velocity += acceleration;
    this.velocity *= this.damping;
    if (this.maxSpeed<this.velocity){this.velocity = this.maxSpeed;}
    if (0-this.maxSpeed>this.velocity){this.velocity =0-this.maxSpeed;}
    this.output += this.velocity;

    return this.output;
  }
}

export class DoubleSpring{

  constructor(options1, options2){
    this.output = 0;

    this.s1 = new Spring(options1);
    this.s2 = new Spring(options2);
  }

  reset(input){
    this.s1.output=input;
    this.s2.output=input;
    this.output=input;

    this.s1.velocity=0;
    this.s2.velocity=0; 
  }

  updateOptions(options1 = {}, options2 = {}){
    Object.assign(this.s1, options1)
    Object.assign(this.s2, options2)
  }

  process(input){
    this.s1.process(input);
    this.s2.process(this.s1.output);
    this.output = this.s2.output;

    return this.output;
  }
}